import Vue from 'vue'
import axios from 'axios'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.longQuery) this.$longQuery = options.longQuery
    else if (options.parent && options.parent.$longQuery)
      this.$longQuery = options.parent.$longQuery
  },
})

const storage = sessionStorage
const lastingStorage = localStorage

class DummyEventSource {
  constructor() {
    this.listeners = {}
  }
  addEventListener(eventName, f) {
    this.listeners[eventName] = f
  }
  close() {
    // NOP
  }
}

const eventSources = new Set()

function broadCast(message) {
  eventSources.forEach(e => e.listeners['message'](message))
}

export default {
  connect() {
    const eventSource = new DummyEventSource()
    eventSources.add(eventSource)
    return eventSource
  },
  saveQueryFilter(queryId, queryFilter) {
    return new Promise(r => {
      storage.setItem(
        `giggle.queryfilter.${queryId}`,
        JSON.stringify(queryFilter),
      )
      r(queryId)
    })
  },
  saveMenuQueryFilter(resourceName, queryFilter) {
    lastingStorage.setItem(
      `giggle.queryfilter.${resourceName}.latest`,
      JSON.stringify(queryFilter),
    )
    return Promise.resolve(undefined)
  },
  fetchMenuQueryFilter(menuCode) {
    const queryFilter = lastingStorage.getItem(
      `giggle.queryfilter.${menuCode}.latest`,
    )

    if (queryFilter) {
      return Promise.resolve(JSON.parse(queryFilter))
    } else {
      return Promise.resolve(undefined)
    }
  },
  /**
   * 画面遷移ができないルートを追加します
   *
   * 分析実行時の各種分析IDから遷移できないルート操作を判定します。
   *
   * queryIdsに入っているIDは以下の通り
   *
   * * ref
   *
   * 画面遷移で引き継ぐIDとして指定された分析ID。このIDに貯められているルートに
   * 今回のルートを追加します。
   *
   * * current
   *
   * 直前に実行された分析の分析ID。このIDにブロックルートを紐付けます。
   * たとえ今までのブロックルートがあったとしても、自画面の分析ボタンを押したら
   * 履歴はリセットされます。
   *
   * @param {Object} queryIds
   * @param {String} resourceName
   * @param {String} option
   */
  pushBlockRoute({ ref, current }, resourceName, option) {
    let history = ''
    if (ref) {
      history = storage.getItem(`giggle.blockroute.${ref}`)
    }

    const route = resourceName + (option ? `/${option}` : '')

    storage.setItem(`giggle.blockroute.${current}`, [history, route].join(' '))

    return Promise.resolve()
  },
  fetchBlockRoute(queryId) {
    return Promise.resolve(
      storage.getItem(`giggle.blockroute.${queryId}`).split(' '),
    )
  },
  fetchQueryFilter(queryId) {
    return new Promise(r => {
      r(JSON.parse(storage.getItem(`giggle.queryfilter.${queryId}`)))
    })
  },
  executeQuery(resourceName, postData) {
    const id = new Date().getTime().toString()

    // eslint-disable-next-line no-console
    console.log('query with', postData)

    setTimeout(async () => {
      broadCast({
        data: JSON.stringify({
          id,
          status: 'Completed',
          grid: (await axios.get(`/query/${resourceName}/grid.json`)).data,
        }),
      })
    }, 1500)

    return new Promise(r => {
      r({ id, status: 'Working' })
    })
  },
  fetchQueryInfo(resourceName, queryId) {
    return new Promise(r => {
      setTimeout(async () => {
        r({
          queryId,
          status: 'Completed',
          grid: (await axios.get(`/query/${resourceName}/grid.json`)).data,
          hasData: true,
        })
      }, 500)
    })
  },
  getQueryResultFetchUrl(resourceName) {
    return `/query/${resourceName}/data.json`
  },
}
